import { useContext, useEffect } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { FaPencilAlt } from "react-icons/fa";
import { Navigate } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { setUserDetailsStore, useUserDetailsStore } from "../..";
import { DP } from "../../../../common/types";
import Spinner from "../../../../components/Spinner";
import { ProfileContext } from "../../../../context/profileContext";
import { fetchGetUserDetails } from "../../api";
import SubscribeButton from "../SubscribeButton";
import WriteAbout from "./components/WriteAbout";

interface Props extends DP {}

const UserInfo = (props: Props) => {
  const profile = useContext(ProfileContext);

  const isLoading = useUserDetailsStore((s) => s.isUserInfoLoading);
  const user = useUserDetailsStore((s) => s.user);
  const username = useUserDetailsStore((s) => s.username);
	const isDescriptionEditing = useUserDetailsStore((s) => s.isDescriptionEditing)

	const handleDescEdit = () => {
		setUserDetailsStore({isDescriptionEditing: true, descInput: user.description})
	}

  useEffect(() => {
    fetchGetUserDetails();
  }, [username]);

  if (isLoading) return <Spinner />;
  if (!user) return <Navigate replace to={"/notFound"} />;

	const isOwner = profile?.user._id == user._id;

  return (
    <Wrapper className={props.className}>
      <UserPicture src={user.picture} />
      <Username>{user.username}</Username>
      {user.description && !isDescriptionEditing ? (
        <Description>
          <span>{user.description}</span>
          {isOwner && (
            <EditButton onClick={handleDescEdit}>
              <FaPencilAlt />
            </EditButton>
          )}
        </Description>
      ) : (
        isOwner && <WriteAbout />
      )}
      <InfoIconsWrapper>
        {!isOwner && <SubscribeButton />}
        <SubscribersCount />
      </InfoIconsWrapper>
    </Wrapper>
  );
};

const SubscribersCount = styled(() => {
  const subsCount = useUserDetailsStore((s) => s.user.subsCount);

  return (
    <InfoItem>
      <BsFillPersonFill />
      <span>{subsCount} subscribers</span>
    </InfoItem>
  );
})``;

const Wrapper = styled.div(() => [
  tw`mt-4`,
  css`
    display: grid;
    grid-template:
      "pic username"
      "pic desc"
      "pic iconsWr"
      / auto 5fr;
    gap: 0.5rem;

    ${UserPicture} {
      grid-area: pic;
    }
    ${Username} {
      grid-area: username;
    }
    ${Description}, ${WriteAbout} {
      grid-area: desc;
    }
    ${InfoIconsWrapper} {
      grid-area: iconsWr;
    }
  `,
]);

const UserPicture = styled.img(() => [
  tw`rounded-circle w-[5rem] m-auto aspect-square object-cover`,
]);

const Username = styled.div(() => [tw`text-[0.6rem] mt-[1rem]`]);

const Description = styled.div(() => [tw`text-[0.35rem]`]);

const InfoIconsWrapper = styled.div(() => [tw`flex space-x-1 text-[0.3rem]`]);

const InfoItem = styled.div(() => [
  tw`flex space-x-0.5 items-center text-pink-400 text-[0.4rem]`,
]);

const EditButton = styled.button(() => [
  tw`text-[0.25rem] p-1`,
  css`
    opacity: 0.3;
    @media (hover: hover) {
      opacity: 0;
      ${Description}:hover & {
        opacity: 0.3;
      }
    }
  `,
]);

export default styled(UserInfo)``;
